export const CERTIFICATES = "CERTIFICATES"

export const CERTIFICATE = "CERTIFICATE"

export const CERTIFICATE_USER = "CERTIFICATE_USER"

export const CERTIFICATE_ACTIVITY_STATUS_INFO = "CERTIFICATE_ACTIVITY_STATUS_INFO"